import { render } from "./Popover.vue?vue&type=template&id=6f4f37f4&scoped=true"
import script from "./Popover.vue?vue&type=script&lang=js"
export * from "./Popover.vue?vue&type=script&lang=js"

import "./Popover.vue?vue&type=style&index=0&id=6f4f37f4&scoped=true&lang=css"

import exportComponent from "/Users/abinop/code/Filisia-Dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f4f37f4"]])

export default __exports__